import React from 'react'

const Service = () => {
  return (
    <>
      <div className='MainService'>
        <div className='serviceText'>
            <h4>Services</h4>
            <h2>Check out the great services we offer</h2>
            <div></div>
        </div>
        <div className='serviceBox'>
            <div className='servicePallate'>
            <i className="fa fa-calendar-check-o"></i>
            <h3>Lorem Ipsum</h3>
            <p>Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate</p>
            </div>
            <div className='servicePallate'>
            <i className="fa fa-calendar-check-o"></i>
            <h3>Lorem Ipsum</h3>
            <p>Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate</p>
            </div>
            <div className='servicePallate'>
            <i className="fa fa-calendar-check-o"></i>
            <h3>Lorem Ipsum</h3>
            <p>Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate</p>
            </div>
            <div className='servicePallate'>
            <i className="fa fa-calendar-check-o"></i>
            <h3>Lorem Ipsum</h3>
            <p>Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate</p>
            </div>
        </div>
      </div>
    </>
  )
}

export default Service
